import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-directory",
  "use": "icon-directory-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-directory\"><path d=\"M22.3 178.1h979.5c12.2 0 22.3-10 22.3-22.3 0-12.2-10-22.3-22.3-22.3H22.3C10 133.6 0 143.6 0 155.8c0 12.3 10 22.3 22.3 22.3zM1001.7 845.9H22.3C10 845.9 0 855.9 0 868.2c0 12.2 10 22.3 22.3 22.3h979.5c12.2 0 22.3-10 22.3-22.3-0.1-12.3-10.1-22.3-22.4-22.3zM1001.7 489.7H22.3C10 489.7 0 499.8 0 512s10 22.3 22.3 22.3h979.5c12.2 0 22.3-10 22.3-22.3s-10.1-22.3-22.4-22.3z\" fill=\"\" p-id=\"10381\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol